import { apiClient } from './api';

export const loginUser = async (userInfo) => {
    try {
        const response = await apiClient.login(userInfo.account, userInfo.password);
        if (response.user) {
            window.localStorage.setItem("user", JSON.stringify(response.user));
            return response.user;
        }
        return null;
    } catch (error) {
        console.error("Login failed:", error);
        throw error;
    }
};

export const getCurrentUser = () => {
    let user = window.localStorage.getItem("user");
    if (!user) return null;
    try {
        user = JSON.parse(user);
        console.log("currentUser:", user);
        return user;
    } catch (error) {
        console.error("Error parsing user data:", error);
        window.localStorage.removeItem("user");
        return null;
    }
};

export const logoutUser = () => {
    apiClient.logout();
    window.localStorage.removeItem("user");
};

// Hook for checking authentication status
export const useLogin = () => {
    const isAuthenticated = () => {
        const token = localStorage.getItem('token');
        return !!token;
    };

    const requireAuth = () => {
        if (!isAuthenticated()) {
            window.location.href = '/login';
        }
    };

    return {
        isAuthenticated,
        requireAuth,
        currentUser: getCurrentUser(),
    };
};
